
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { submit as submitForm, change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import FormControl from 'react-bootstrap/lib/FormControl';
import Button from 'react-bootstrap/lib/Button';
import { reduxForm } from 'redux-form';
import cx from 'classnames';

import DateRange from '../../Home/DateRange/DateRange';
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import MobileDateRange from '../../Home/MobileDateRange/MobileDateRange';

import { changePersonalizedData } from '../../../actions/toggleControl';
import { getSpecificSettings } from '../../../actions/getSpecificSettings';
import { setPersonalizedValues } from '../../../actions/personalized';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import { searchFormSuggestSelect, changeSearchForm } from '../../../helpers/GeoSuggest/updateSearchForm';
import messages from '../../../locale/messages';
import searchLocation from '../../../helpers/searchLocation';

import { withQuery } from '../../../hoc/withGraphql';
import { getPopularLocationAdmin } from '../../../lib/graphql';
import { locationuploadDir } from '../../../config';

import searchIcon from '/public/SiteIcons/searchIconHome.svg';
import locationIcon from '/public/SiteIcons/location.svg';
import calendarIcon from '/public/SiteIcons/calendar.svg';
import peopleIcon from '/public/SiteIcons/people.svg';
/* import personajeSearch from '/public/SiteImages/personaje-lupa.svg'; */

import bt from '../../commonStyle.css';
import s from './SearchForm.css';

class SearchForm extends React.Component {
  static propTypes = {
    setPersonalizedValues: PropTypes.any.isRequired,
    getSpecificSettings: PropTypes.any.isRequired,
    personalized: PropTypes.shape({
      location: PropTypes.string,
      lat: PropTypes.number,
      lng: PropTypes.number,
      chosen: PropTypes.number,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      personCapacity: PropTypes.number,
      formatMessage: PropTypes.any,
      isOneTotalToggle: PropTypes.bool,
    }),
    settingsData: PropTypes.shape({
      listSettings: PropTypes.array.isRequired
    }).isRequired
  };

  static defaultProps = {
    listingFields: []
  };

  static defaultProps = {
    personalized: {
      location: null,
      lat: null,
      lng: null,
      startDate: null,
      endDate: null,
      personCapacity: null,
      chosen: null
    },
    settingsData: {
      listSettings: []
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      mobileDevice: false,
      personCapacity: [],
      isLoad: false,
      smallDevice: false,
      isOneTotalToggle: false,
      activeField: null
    };
    this.formRef = createRef();
  }

  componentDidMount() {
    this.setState({ isLoad: false });
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields, personalized } = nextProps;
    const { setPersonalizedValues } = this.props;
    if (listingFields != undefined) {
      !personalized.personCapacity && setPersonalizedValues({ name: 'personCapacity', value: Number(listingFields?.personCapacity[0]?.startValue) });
      this.setState({
        personCapacity: listingFields.personCapacity
      });
    }
    if (personalized.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized.isOneTotalToggle })
  }

  UNSAFE_componentWillMount() {
    const { listingFields, personalized } = this.props;
    if (listingFields != undefined) {
      this.setState({
        personCapacity: listingFields.personCapacity
      });
    }
    if (detectMobileBrowsers.isMobile() === true) {
      this.setState({ mobileDevice: true });
    }
    if (personalized.isOneTotalToggle) this.setState({ isOneTotalToggle: personalized.isOneTotalToggle })
  }

  componentWillUnmount() {
    let isBrowser = typeof window !== 'undefined';
    if (isBrowser) {
      window.removeEventListener('resize', this.handleResize);
    }
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleResize = (e) => {
    let isBrowser = typeof window !== 'undefined';
    let smallDevice = isBrowser ? window.matchMedia('(max-width: 767px)').matches : true;
    this.setState({ smallDevice });
  }

  handleFieldClick = (field, inputId) => {
    this.setState({ activeField: field });
    if (inputId) {
      const el = document.getElementById(inputId);
      if (el) setTimeout(() => el.focus(), 50);
    }
  }

  handleClickOutside = (e) => {
    if (this.formRef.current && !this.formRef.current.contains(e.target)) {
      this.setState({ activeField: null });
    }
  }

  handleClick = async () => {
    const { personalized, page, submitForm, setPersonalizedValues, change, changePersonalizedData } = this.props;
    let uri = '/s?';

    if (personalized?.searchLocationStatus) {
      searchLocation(setPersonalizedValues, personalized?.startDate, personalized?.endDate, change, personalized?.personCapacity, uri, personalized?.searchLocationStatus);
    } else {
      if (page != 'search' || (page == 'search' && (personalized?.chosen || personalized?.location))) {

        if (personalized?.chosen) {
          uri = uri + '&address=' + personalized?.location + '&chosen=' + personalized?.chosen;
        } else if (personalized?.location) {
          uri = uri + '&address=' + personalized?.location;
        }

        searchLocation(setPersonalizedValues, personalized?.startDate, personalized?.endDate, change, personalized?.personCapacity, uri);
      } else {
        if (personalized?.startDate && personalized?.endDate) {
          setPersonalizedValues({ name: 'isOneTotalToggle', value: true });
          change('SearchForm', 'isOneTotalToggle', true);
        }
        await changePersonalizedData('SearchForm', 'currentPage', 1);
        await submitForm('SearchForm');
        window.scrollTo({
          top: 0,
          left: 0
        });
      }
    }
  }

  formValue = (e) => {
    const { setPersonalizedValues, changePersonalizedData } = this.props;
    changePersonalizedData('SearchForm', 'personCapacity', e);
    setPersonalizedValues({ name: 'personCapacity', value: Number(e) })
  }

  onSuggestSelect = (data, value) => {
    const { setPersonalizedValues, change } = this.props;
    searchFormSuggestSelect({ data, setPersonalizedValues, value, change: (field, val) => change('SearchForm', field, val) });
  }

  onChange = async (value) => {
    const { setPersonalizedValues, change } = this.props;
    if (value == '') {
      changeSearchForm({ setPersonalizedValues, change });
    }
  }

  render() {
    const { viewListingHeader, guests, personalized } = this.props;
    const { formatMessage } = this.props.intl;
    const { personCapacity, smallDevice } = this.state;
    let rows = [], guestCount = 1;
    if (personCapacity?.[0] && personCapacity[0]?.startValue) {
      for (let i = personCapacity[0]?.startValue; i <= personCapacity[0]?.endValue; i++) {
        rows.push(<option value={i} key={i}>{i} {i > 1 ? personCapacity[0]?.otherItemName : personCapacity[0]?.itemName}</option>);
      }
    }
    if (personalized?.personCapacity) {
      guestCount = personalized?.personCapacity;
    } else if (personCapacity?.[0] && personCapacity[0].startValue) {
      guestCount = personCapacity[0]?.startValue;
    }

    if (!personalized?.personCapacity && viewListingHeader == 'viewListingHeader') guestCount = guests;

    return (
      <div className={cx(s.searchFormWrapper)}>
       {/*  <img src={personajeSearch} alt="" className={cx('personajeSearchHeader', s.personajeImage)} /> */}
        <div className={cx('homeSearchForm', 'verticalsearchform', 'layout5Searchform')} ref={this.formRef}>
          <div className={cx(s.searchForm, 'searchForm', { [s.formHasActive]: this.state.activeField })}>
            <div className={cx(s.fieldWrapper, s.sideBorder, 'sideBorder', { [s.fieldActive]: this.state.activeField === 'location', [s.fieldInactive]: this.state.activeField && this.state.activeField !== 'location' })} onClick={() => this.handleFieldClick('location', 'headerSearch')}>
              <label className={cx(s.label, s.whereLabelPadding)}>
                <span><FormattedMessage {...messages.where} /></span>
              </label>
              <PlaceGeoSuggest
                placeholder={formatMessage(messages.homeWhere)}
                className={cx(s.formControlInput, s.layout2LocationSuggestInput, s.input, 'newGeoSuggestInput', s.textEllipsis)}
                initialValue={personalized?.location}
                onChange={this.onChange}
                onSuggestSelect={this.onSuggestSelect}
                id={'headerSearch'}
                containerClass='searchHeaderGeoSuggest'
                popularLocations={this.props.popularLocationData?.getPopularLocationAdmin}
                locationuploadDir={locationuploadDir}
              />
              <img src={locationIcon} className={s.inputIcon} alt="" />
            </div>
            <div className={cx(s.fieldWrapper, s.sideBorder, 'sideBorder', { [s.fieldActive]: this.state.activeField === 'dates', [s.fieldInactive]: this.state.activeField && this.state.activeField !== 'dates' })} onClick={() => this.handleFieldClick('dates', null)}>
              <label className={cx(s.label, s.dateLabel)}>
                <span><FormattedMessage {...messages.when} /></span>
              </label>
              <span className={cx('homeDate', s.formControlInput, s.input, 'homeDateAR', 'homeSerachDate')}>
                {
                  !smallDevice && <DateRange
                    formName={'SearchForm'}
                    numberOfMonths={2}
                  />
                }
                {
                  smallDevice && <MobileDateRange
                    formName={'SearchForm'}
                    numberOfMonths={1}
                  />
                }
              </span>
              <img src={calendarIcon} className={s.inputIcon} alt="" />
            </div>
            <div className={cx(s.fieldWrapper, { [s.fieldActive]: this.state.activeField === 'guests', [s.fieldInactive]: this.state.activeField && this.state.activeField !== 'guests' })} onClick={() => this.handleFieldClick('guests', 'guestSelect')}>
              <label className={cx(s.selectPadding, s.label)}>
                <span><FormattedMessage {...messages.guest} /></span>
              </label>
              <div className={s.guestCounter}>
                <button
                  type="button"
                  className={s.counterBtn}
                  onClick={() => {
                    const current = personalized?.personCapacity || 1;
                    if (current > 1) {
                      this.props.setPersonalizedValues({ name: 'personCapacity', value: current - 1 });
                    }
                  }}
                  disabled={(personalized?.personCapacity || 1) <= 1}
                >
                  −
                </button>
                <span className={s.counterValue}>
                  {personalized?.personCapacity || 1} {((personalized?.personCapacity || 1) > 1) ? personCapacity?.[0]?.otherItemName : personCapacity?.[0]?.itemName}
                </span>
                <button
                  type="button"
                  className={s.counterBtn}
                  onClick={() => {
                    const current = personalized?.personCapacity || 1;
                    if (current < 20) {
                      this.props.setPersonalizedValues({ name: 'personCapacity', value: current + 1 });
                    }
                  }}
                  disabled={(personalized?.personCapacity || 1) >= 20}
                >
                  +
                </button>
              </div>
              <img src={peopleIcon} className={s.inputIcon} alt="" />
            </div>
            <div className={s.buttonContainer}>
              <Button className={cx(bt.btnPrimary, s.btnBlock, s.searchButton, 'layOut5SearchBtn', { [s.btnExpanded]: this.state.activeField })} onClick={this.handleClick}>
                <img src={searchIcon} alt="Search" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SearchForm = reduxForm({
  form: 'HeaderSearchForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(SearchForm);

const mapState = (state) => ({
  personalized: state.personalized,
  settingsData: state.viewListing.settingsData,
  listingFields: state.listingFields.data,
  isOneTotalToggle: state.personalized.isOneTotalToggle,
});

const mapDispatch = {
  getSpecificSettings,
  setPersonalizedValues,
  submitForm,
  change,
  changePersonalizedData
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withQuery(getPopularLocationAdmin, { name: 'popularLocationData', options: { ssr: false } }),
)(SearchForm);